import Sider from "antd/es/layout/Sider";
import styled from "styled-components";
import { secondaryColor, thirdColor } from "../../../config";

export const Wrapper = styled(Sider)`
.menu-sub-dropdown { display: block;}

`;
export const ProfileView = styled.div`
.menu-sub-dropdown { display: block;}
  
`;

export const MenuView = styled.div`
.ant-menu-inline .ant-menu-item, .ant-menu-vertical .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-submenu-title {
    margin-inline: 0px;
    margin-block: 4px;
    width: calc(100% - 0px);
}
.ant-menu-light.ant-menu-root.ant-menu-inline, .ant-menu-light>.ant-menu.ant-menu-root.ant-menu-inline, .ant-menu-light.ant-menu-root.ant-menu-vertical, .ant-menu-light>.ant-menu.ant-menu-root.ant-menu-vertical {
    border-inline-end: 1px solid rgba(255, 255, 255, 0);
}
    .ant-menu-light .ant-menu-item-selected, .ant-menu-light>.ant-menu .ant-menu-item-selected {
    background-color: #f45b68;
}

.ant-menu-light .ant-menu-item-selected, .ant-menu-light>.ant-menu .ant-menu-item-selected {
    color: #ffffff;
}
.ant-menu-title-content span, .ant-menu-title-content{
    font-size: 1.1rem;
    font-weight: 600;
}
.ant-menu-light .ant-menu-item-selected i, .ant-menu-light>.ant-menu .ant-menu-item-selected i {
    color: #fff !important;
}
.ant-menu-item-icon{color:#f45b68 !important}

.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color:#181C32;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover .ant-menu-title-content, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover  .ant-menu-title-content{
    color:#fff;
}
 .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover {
        background-color:#181C32;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-title-content{
       color:#fff;
}
.ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow, .ant-menu-light>.ant-menu:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover .ant-menu-submenu-arrow{
       color:#fff;
}
.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title, .ant-menu-light>.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title {
    // color: #f45b68;
}
.ant-menu-light .ant-menu-item-selected .menu-bullet .bullet, .ant-menu-light>.ant-menu .ant-menu-item-selected .menu-bullet .bullet{
    background-color:#fff;
}
.ant-menu-item, .ant-menu-submenu-title{padding-left:15px !important}
.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-title-content {
    color: #000000;
}
.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title .ant-menu-submenu-arrow{
    color: #000000;
}

`;